export const GridConfigDefault = {
  resizable: true,
  suppressMenu: false,
  suppressMovableColumns: true,
  editable: false
};
